(function () {
  const root = document.querySelector("[data-cita-cal]");
  if (!root) {
    return;
  }

  const monthLabel = root.querySelector("[data-cita-month]");
  const daysEl = root.querySelector("[data-cita-days]");
  const slotsEl = root.querySelector("[data-cita-slots]");
  const prevBtn = root.querySelector("[data-cita-prev]");
  const nextBtn = root.querySelector("[data-cita-next]");
  const dateInput = root.querySelector("[data-cita-date]");
  const timeInput = root.querySelector("[data-cita-time]");
  const waLink = root.querySelector("[data-cita-wa]");
  const hint = root.querySelector("[data-cita-hint]");
  const weekdayNames = ["L", "M", "X", "J", "V", "S", "D"];
  const weekdaySlots = ["09:00", "11:00", "13:00", "16:00", "18:00"];
  const saturdaySlots = ["09:00", "11:00", "13:00"];
  const maxDays = 45;
  const today = startOfDay(new Date());
  const maxDate = addDays(today, maxDays);
  let view = new Date(today.getFullYear(), today.getMonth(), 1);
  let selectedDate = null;
  let selectedTime = "";

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function addDays(date, amount) {
    const next = new Date(date);
    next.setDate(next.getDate() + amount);
    return next;
  }

  function iso(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return y + "-" + m + "-" + d;
  }

  function isClosed(date) {
    return date.getDay() === 0;
  }

  function isDisabled(date) {
    const day = startOfDay(date);
    if (day < today) {
      return true;
    }
    if (day > maxDate) {
      return true;
    }
    if (isClosed(day)) {
      return true;
    }
    return false;
  }

  function slotsFor(date) {
    if (!date || isDisabled(date)) {
      return [];
    }
    if (date.getDay() === 6) {
      return saturdaySlots.slice();
    }
    return weekdaySlots.slice();
  }

  function renderMonth() {
    const label = new Intl.DateTimeFormat("es-ES", {
      month: "long",
      year: "numeric",
    }).format(view);
    monthLabel.textContent = label.charAt(0).toUpperCase() + label.slice(1);
    daysEl.replaceChildren();
    const first = new Date(view.getFullYear(), view.getMonth(), 1);
    const offset = (first.getDay() + 6) % 7;
    const lastDate = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
    for (let i = 0; i < offset; i += 1) {
      const empty = document.createElement("span");
      daysEl.appendChild(empty);
    }
    for (let day = 1; day <= lastDate; day += 1) {
      const date = new Date(view.getFullYear(), view.getMonth(), day);
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cita-cal__day";
      btn.textContent = String(day);
      btn.disabled = isDisabled(date);
      if (iso(date) === iso(today)) {
        btn.classList.add("is-today");
      }
      if (selectedDate && iso(date) === iso(selectedDate)) {
        btn.classList.add("is-selected");
      }
      btn.addEventListener("click", function () {
        selectedDate = date;
        selectedTime = "";
        dateInput.value = iso(date);
        timeInput.value = "";
        renderMonth();
        renderSlots();
        updateWa();
      });
      daysEl.appendChild(btn);
    }
  }

  function renderSlots() {
    slotsEl.replaceChildren();
    const slots = slotsFor(selectedDate);
    if (!selectedDate) {
      hint.textContent = "Elige un día laborable. Domingo cerrado.";
      return;
    }
    if (slots.length === 0) {
      hint.textContent = "Ese día no hay franja. Prueba otro.";
      return;
    }
    hint.textContent = selectedDate.getDay() === 6
      ? "Sábado: solo mañana. Confirmamos por WhatsApp."
      : "Franja orientativa. Confirmamos por WhatsApp o teléfono.";
    slots.forEach(function (slot) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "cita-cal__slot";
      btn.textContent = slot;
      if (slot === selectedTime) {
        btn.classList.add("is-selected");
      }
      btn.addEventListener("click", function () {
        selectedTime = slot;
        timeInput.value = slot;
        renderSlots();
        updateWa();
      });
      slotsEl.appendChild(btn);
    });
  }

  function updateWa() {
    if (!waLink) {
      return;
    }
    const tipo = root.querySelector("[data-cita-tipo]");
    const nombre = root.querySelector("[data-cita-nombre]");
    const parts = ["Hola, quiero una cita de Madrid Clima."];
    if (tipo && tipo.value) {
      parts.push("Tipo: " + tipo.value);
    }
    const producto = root.querySelector('input[name="contact[Producto]"]');
    if (producto && producto.value) {
      parts.push("Servicio: " + producto.value);
    }
    if (dateInput.value) {
      parts.push("Fecha: " + dateInput.value);
    }
    if (timeInput.value) {
      parts.push("Hora: " + timeInput.value);
    }
    if (nombre && nombre.value) {
      parts.push("Soy " + nombre.value);
    }
    const text = encodeURIComponent(parts.join(" "));
    waLink.href = "https://api.whatsapp.com/send/?phone=34610321303&text=" + text;
  }

  prevBtn.addEventListener("click", function () {
    view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
    renderMonth();
  });
  nextBtn.addEventListener("click", function () {
    view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
    renderMonth();
  });
  root.addEventListener("input", updateWa);

  weekdayNames.forEach(function (name) {
    const el = document.createElement("span");
    el.textContent = name;
    root.querySelector("[data-cita-weekdays]").appendChild(el);
  });

  renderMonth();
  renderSlots();
  updateWa();
})();
